






















import { Component, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue {
  showUpdate = false;
  registration?: ServiceWorkerRegistration;
  refreshing = false;

  created() {
    console.log("listening for SW messages");
    document.addEventListener(
      "swUpdated",
      event => {
        console.log("got SW message: ", event);
        if (event.type == "swUpdated") {
          console.log("This is sw updated event, we need to reload");
          this.registration = (event as CustomEvent).detail;
          console.log("registratio is set to: " + this.registration);
          this.showUpdate = true;
        }
      },
      { once: true }
    );

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log("controllrtchsange: " + this.refreshing);
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  }
  refresh() {
    console.log("preparing cahce reload " + this.registration);
    if (!this.registration || !this.registration.waiting) {
      return;
    }
    console.log("posting skipwaiting");
    this.registration.waiting.postMessage("skipWaiting");
  }
}
